import React from 'react';
import { styled } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const DialogActionSection = ({
  children
}) => /*#__PURE__*/_jsx(ActionSection, {
  children: children
});
const ActionSection = styled.section.withConfig({
  displayName: "DialogActionSection__ActionSection",
  componentId: "sc-wzhf6i-0"
})(["display:grid;grid-auto-columns:min-content;justify-content:right;grid-auto-flow:column;justify-content:flex-end;margin-left:auto;grid-gap:8px;margin-top:24px;"]);